import { mediaData } from '@/mocks/home';

export default function SectionMedia() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            吃瓜现场
          </h2>
          <p className="text-sm text-foreground-500">独家视频直击娱乐圈最新动态</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors">
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-950 leading-snug mb-2 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}